<template>
  <div class="bread_crumbs-1">
    <Link01 />
    <div class="text-2 avenirnextltpro-demi-normal-big-stone-10px">/</div>
    <ActualSection />
  </div>
</template>

<script>
import Link01 from '@/components/Sections/HeaderFigmaTeams/Link01';
import ActualSection from '@/components/Sections/HeaderFigmaTeams/ActualSection';
export default {
  name: 'BreadCrumbs',
  components: {
    Link01,
    ActualSection,
  },
};
</script>

<style>
.bread_crumbs-1,
.bread_crumbs-2,
.bread_crumbs-3 {
  align-items: center;
  display: flex;
  justify-content: left;
  padding: 0px 0px 0px 4px;
  position: relative;
  width: 100%;
}

.text-2,
.text-3,
.text-5 {
  letter-spacing: -0.1px;
  line-height: 17px;
  opacity: 0.4;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}
</style>
